<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>{{ $t('사업장 정보') }}</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('사업장명') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_1"
            :placeholder="$t('선택')"
            @select="targetCompany"
          ></CompanySelector>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('사업주 또는 대표자') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('전화번호') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('주소') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_4 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('사업금액') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_5 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_5"
          />
        </div>
      </div>
    </div>

    <!--안전담당자-->
    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>{{ $t('안전담당자') }}</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('성명') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_1 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('소속명') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_2 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('직책') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_3 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('자격/면허번호') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_4 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('선임일') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_5 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder="날짜선택"
            v-model="form.inputC_5"
          />
        </div>
      </div>
    </div>

    <!--보건담당자-->
    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>{{ $t('보건담당자') }}</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('성명') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_1 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('소속명') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_2 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('직책') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_3 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('자격/면허번호') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_4 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('선임일') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_5 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder="날짜선택"
            v-model="form.inputD_5"
          />
        </div>
      </div>
    </div>
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import SearchNavStartEnd from '../../../../components/nav/SearchNavStartEnd.vue'
import FileUploadModule from '../../../modules/FileUploadModule.vue'
import FieldSelectModule from '@/views/modules/FieldSelectModule'

export default {
  components: {
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},

        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',
        inputB_5: '',
        inputC_1: '',
        inputC_2: '',
        inputC_3: '',
        inputC_4: '',
        inputC_5: '',
        inputD_1: '',
        inputD_2: '',
        inputD_3: '',
        inputD_4: '',
        inputD_5: '',
        fileList: [],
        companyName:'',
      },
    }
  },
  methods: {
    targetCompany (value) {
      this.form.companyName = value.com_name
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;
    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
</style>
